import { useColorScheme } from '@/hooks/use-color-scheme';
import { DarkTheme, DefaultTheme, ThemeProvider } from '@react-navigation/native';

const ProviderContent = ({ children }: React.PropsWithChildren) => {
  const colorScheme = useColorScheme();

  return <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>{children}</ThemeProvider>;
};

export default ProviderContent;
